var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',[_c('div',{staticClass:"outer"},[_c('header',{staticClass:"header"},[_c('div',{staticClass:"header-content"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo_mmt_blanco_transparente.png")}})])])])])}]

export { render, staticRenderFns }